import { createLogger } from '#environment/createLogger.js';
import { isAxiosError } from 'axios';
import { addErrorParser, parseError, } from '@cbbt/lib-error-parser';
const defaultLogConfig = {
    level: 'debug',
    request: false,
    response: false,
    error: false,
    data: false,
};
const axiosErrorParser = (error) => {
    if (isAxiosError(error)) {
        return {
            request: error.config && {
                method: error.config.method,
                baseURL: error.config.baseURL,
                url: error.config.url,
            },
            response: error.response && {
                status: error.response.status,
            },
        };
    }
    return undefined;
};
addErrorParser(axiosErrorParser);
export const setupLogs = (axiosInstance, config) => {
    const logger = createLogger(config.name);
    const logConfig = Object.assign({}, defaultLogConfig, config.log);
    if (logConfig.request) {
        axiosInstance.interceptors.request.use((request) => {
            logger[logConfig.level]('API Request', {
                request: {
                    method: request.method,
                    baseURL: request.baseURL,
                    url: request.url,
                    ...(logConfig.data && {
                        headers: request.headers.toJSON(),
                        params: request.params,
                        data: request.data,
                    }),
                },
            });
            return request;
        });
    }
    if (logConfig.response) {
        axiosInstance.interceptors.response.use((response) => {
            logger[logConfig.level]('API Response', {
                request: {
                    method: response.config.method,
                    baseURL: response.config.baseURL,
                    url: response.config.url,
                },
                response: {
                    status: response.status,
                    ...(logConfig.data && {
                        headers: response.headers,
                        data: response.data,
                    }),
                },
            });
            return response;
        });
    }
    if (logConfig.error) {
        axiosInstance.interceptors.response.use(null, (error) => {
            const parsed = parseError(error);
            if (isAxiosError(error) && logConfig.data) {
                Object.assign(parsed.request, error.config && {
                    headers: error.config.headers.toJSON(),
                    params: error.config.params,
                    data: error.config.data,
                });
                Object.assign(parsed.response, error.response && {
                    headers: error.response.headers,
                    data: error.response.data,
                });
            }
            logger.error('API Error', parsed);
            return Promise.reject(error);
        });
    }
};
//# sourceMappingURL=setupLogs.js.map